
import BScroll from "better-scroll";
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import Cookies from "js-cookie";
export default {
components: {
XInput,
Group,
XButton
},
data() {
return {
oldPassword: "",
newPassword: "",
conPassword: "",
bscroll: ""
};
},
mounted() {
this.initScroll();
},
computed: {
btn_default() {
return !(this.oldPassword && this.newPassword && this.conPassword);
}
},
methods: {
showErrMsg() {
this.$vux.toast.text("必填");
},
initScroll() {
let wrapper = document.querySelector(".p-card_pwd");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
},
resetForm() {
this.oldPassword = "";
this.newPassword = "";
this.conPassword = "";
},
validate() {
if (this.newPassword != this.conPassword) {
this.$vux.toast.text("两次新密码不一致");
return;
}
this.submitUpdatePwd();
},
submitUpdatePwd() {
this.$vux.loading.show();
this.$http("post", "/user/updatePwd", {
openId: Cookies.get("openId"),
pwd: this.oldPassword,
newPwd: this.newPassword
})
.then(res => {
this.$vux.loading.hide();
this.$vux.toast.text(res.message);
this.$router.push({
path: "/person"
});
})
.catch(() => {
this.$vux.loading.hide();
});
}
}
};
